import { fixedForwardRef } from "@/internals/forward-ref";
import React from "react";
import { Control, FieldPath, FieldValues } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "./ui/form";
import { InputProps } from "./ui/input";
import { Textarea } from "./ui/textarea";

interface FormTextAreaProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> extends InputProps {
  control: Control<TFieldValues>;
  name: TName;
  label?: React.ReactNode;
}

const RawTextArea = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  props: FormTextAreaProps<TFieldValues, TName>,
  ref: React.ForwardedRef<HTMLTextAreaElement>
) => {
  const { control, name, label, ...rest } = props;
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className="w-full ">
          <FormLabel className="text-lg font-medium">{label}</FormLabel>
          <FormControl>
            {/* @ts-expect-error TODO: fix */}
            <Textarea {...rest} {...field} ref={ref} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export const FormTextArea = fixedForwardRef(RawTextArea);
